export default __webpack_public_path__ + "static/media/Group 6513@3x.4d352cd5.png";